import { FC, useEffect } from "react";
// import "../styles/LoadingAnim.scss";
import { openDeletePopup } from "../../store/reducers/ProductDeletePopup/DeletePopup.slice";
import { Button } from "../Button";
import store from "../../store/store";

const DeleteLink: FC<{
  entityData: any;
  entityType: any;
}> = ({ entityData, entityType }) => {
  const openPopup = async (entityData: any, entityType: any) => {
    const convState = { entityType: entityType, entityData: entityData };
    return store.dispatch(openDeletePopup(convState));
  };

  return (
    <Button
      onClick={() => openPopup(entityData, entityType)}
      apparence="danger"
      view="default"
      type="submit"
      size="md"
    >
      <div className="font-normal text-base">Delete</div>
    </Button>
  );
};

export default DeleteLink;
